export default "__VITE_ASSET__BSu0_Ul8__"